const { formatText } = require('core/i18n').i18n;
const { ALPHANUMERIC_REGEX, UUID_REGEX } = require('constants/contactCenter/regex');
const { UUID_TOTAL_LENGTH, UUID_FIRST_HYPHEN_PLACEMENT, INTERACTION_ID_TOTAL_LENGTH } = require('../../constants');
const Storage = require('utilities/storage');

const formatClientId = (tipoPersona, codigoPersona) => {
    var paddingString = '0000000000';
    var totalLength = 10;
    tipoPersona = tipoPersona.toString();
    codigoPersona = codigoPersona.toString();

    return tipoPersona + String(paddingString + codigoPersona).slice(-1 * (totalLength - tipoPersona.length));
}

const generateUniqueIdentifierSession = () => {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

const validateInteractionId = (id = '') => {
    if (id.length < UUID_FIRST_HYPHEN_PLACEMENT + 1) {
        return formatText('stepValidateInteractionId-errorInvalidInteractionId');
    }

    const isUuid = id.length >= UUID_FIRST_HYPHEN_PLACEMENT + 1 && id[UUID_FIRST_HYPHEN_PLACEMENT] === '-';

    if (isUuid) {
        if (id.length !== UUID_TOTAL_LENGTH) {
            return formatText('stepValidateInteractionId-errorUuidLength');
        }

        if (!(UUID_REGEX.test(id))) {
            return formatText('stepValidateInteractionId-errorInvalidInteractionId');
        }

    } else {
        if(id.length !== INTERACTION_ID_TOTAL_LENGTH) {
            return formatText('stepValidateInteractionId-errorInteractionIdLength');
        }
    
        if(!(ALPHANUMERIC_REGEX.test(id))) {
            return formatText('stepValidateInteractionId-errorInvalidInteractionId');
        }
    }

    return '';
}

const hasTokenCredential = () => Storage.cookies.get('tokenCredential');

module.exports = {
    formatClientId,
    generateUniqueIdentifierSession,
    hasTokenCredential,
    validateInteractionId,
}
